module.exports = __webpack_public_path__ + "img/offline-salebox-amount-icon.88e4d2e7.png";